// extracted by mini-css-extract-plugin
module.exports = {"link":"NavigationLink_link__HcyN_","linkText":"NavigationLink_linkText__xCedj"};